export default __webpack_public_path__ + "static/media/bill.f16383df.jpg";